var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useCallback } from 'react';
import Uppy from "@uppy/core";
import DashboardPlugin from "@uppy/dashboard";
import ImageEditor from '@uppy/image-editor';
import { Dashboard } from '@uppy/react';
import ActiveStorageUpload from '@excid3/uppy-activestorage-upload';
import { Button, Dialog, DialogActions, ThemeProvider } from '@mui/material';
import theme from '../theme';
import _ from 'lodash';
var createUppy = function (id, imageEditorOptions) {
    if (imageEditorOptions === void 0) { imageEditorOptions = {}; }
    var uppy = new Uppy({
        id: "Uppy-".concat(id),
        restrictions: {
            maxNumberOfFiles: 1,
            allowedFileTypes: ['image/*']
        },
        autoProceed: true,
        // debug: true,
    })
        .use(DashboardPlugin, {
        hideUploadButton: true,
        thumbnailType: 'image/png',
    })
        .use(ImageEditor, _.merge({
        id: "ImageEditor-".concat(id),
        quality: 0.8,
        cropperOptions: {
        // viewMode: 1,
        // aspectRatio: 1,
        // autoCropArea: 1,
        // scaleX: 1,
        // scaleY: 1,
        // scalable: false,
        // zoomable: false,
        // modal: false,
        // dragMode: "move",
        // cropBoxResizable: true,
        },
        actions: {
        // revert: false,
        // rotate: false,
        // granularRotate: false,
        // flip: false,
        // zoomIn: false,
        // zoomOut: false,
        // cropSquare: false,
        // cropWidescreen: false,
        // cropWidescreenVertical: false,
        }
    }, imageEditorOptions));
    return uppy;
};
var ImageUploadDialog = function (props) {
    var id = useState('ImageUploadDialog' + Math.random())[0];
    var uppy = useState(function () { return createUppy(id, props.options); })[0];
    var _a = useState(), image = _a[0], setImage = _a[1];
    useEffect(function () {
        var _a;
        (_a = uppy === null || uppy === void 0 ? void 0 : uppy.getPlugin("ImageEditor-".concat(id))) === null || _a === void 0 ? void 0 : _a.setOptions(props.options);
    }, [props.options]);
    var uploadFile = useCallback(function (updatedFile) {
        var _a;
        var upload = new ActiveStorageUpload(uppy, {
            directUploadUrl: ((_a = document.querySelector("meta[name='direct-upload-url']")) === null || _a === void 0 ? void 0 : _a.getAttribute("content")) || "/rails/active_storage/direct_uploads"
        });
        // @ts-ignore
        upload.upload(updatedFile, 1, 1);
    }, []);
    var onClose = useCallback(function (image) {
        uppy.cancelAll();
        props.onClose && props.onClose(image);
    }, []);
    useEffect(function () {
        // uppy.on("file-removed", () => setStatus(ComponentStatus.Empty));
        // uppy.on("file-added", () => setStatus(ComponentStatus.Edit));
        // uppy.on('complete', (files: UppyFile) => {
        //   console.log('complete', files)
        // });
        uppy.on('cancel-all', function () {
            // console.log('cancel-all')
            setImage(null);
        });
        uppy.on('file-editor:complete', function (updatedFile) {
            // console.log('file-editor:complete', updatedFile)
            uploadFile(updatedFile);
        });
        uppy.on('file-editor:cancel', function (updatedFile) {
            // console.log('file-editor:cancel')
            uppy.cancelAll();
        });
        uppy.on('upload-error', function (error) {
            console.error('error', error);
        });
        uppy.on('upload-success', function (_file, response) {
            // console.log('file, response', _file, response)
            // uppy.cancelAll()
            setImage(response);
        });
        return function () {
            uppy.cancelAll();
        };
    }, []);
    return (_jsx(ThemeProvider, __assign({ theme: theme }, { children: _jsxs(Dialog, __assign({ open: props.open, onClose: function () { return onClose(); }, sx: {
                '& .uppy-DashboardTab': { display: 'none' },
                '& img.uppy-Dashboard-Item-previewImg': { width: 'auto', height: 'auto' },
                '& .uppy-Dashboard-Item-previewInnerWrap': { background: 'unset' },
            } }, { children: [props.open && _jsx(Dashboard, { uppy: uppy, proudlyDisplayPoweredByUppy: false, showLinkToFileUploadResult: false, hideUploadButton: true, 
                    // hideRetryButton={true}
                    hidePauseResumeButton: true, disableStatusBar: true, disableInformer: false, disableThumbnailGenerator: true, autoOpenFileEditor: true, locale: {
                        strings: {
                            dropPasteFiles: "Drag and Drop image here or  %{browse}  your computer"
                        }
                    } }), _jsxs(DialogActions, { children: [_jsx(Button, __assign({ onClick: function () { return onClose(); } }, { children: "Cancel" })), _jsx(Button, __assign({ variant: 'contained', disabled: !image, onClick: function () { return onClose(image); } }, { children: "Confirm" }))] })] })) })));
};
export default ImageUploadDialog;
